import { render, staticRenderFns } from "./MenuEditStudent.vue?vue&type=template&id=7a7defac&scoped=true&lang=pug&"
import script from "./MenuEditStudent.vue?vue&type=script&lang=ts&"
export * from "./MenuEditStudent.vue?vue&type=script&lang=ts&"
import style0 from "./MenuEditStudent.vue?vue&type=style&index=0&id=7a7defac&prod&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a7defac",
  null
  
)

export default component.exports